import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'
import next from './asset/next.svg'

import AgreeModal from 'widget/AgreeModal'
import Banner from 'widget/Banner'
import ImageModal from 'widget/ImageModal'

import useGetEventDetail from 'entity/event/useGetEventDetail'
import usePostOfficialRegister from 'entity/event/usePostOfficialRegister'
import usePostFreerollRegister from 'entity/event/usePostFreerollRegister'

import DefaultButton from 'shared/ui/DefaultButton'
import officalEventTerm from 'shared/constant/term/officalEventTerm'
import tryoutEventTerm from 'shared/constant/term/tryoutTerm'
import freerollEventTerm from 'shared/constant/term/freerollEventTerm'
import {
	convertEventTypeAsName,
	OFFICIAL,
	PRELIMINARY,
	STORE,
	TRYOUT,
	FREEROLL,
} from 'shared/constant/lookup/eventType'
import {convertEventStateAsName} from 'shared/constant/lookup/eventState'
import {
	convertProGradeAsName,
	UNQUALIFIED,
} from 'shared/constant/lookup/proGrade'
import timestampCalculator from 'shared/lib/timestampCalculator'
import convertMoney from 'shared/lib/convertMoney'
import {Prize, PrizeContainer} from 'shared/ui/PrizeComponents'
import TiptapEditor from 'shared/ui/TiptapEditor'

// 대회 종류별 출력 데이터가 다름 ( 공식, 공식 예선전, 매장, 트라이아웃, 프리롤 )
// 또한 모든 값이 항상 오는 것은 아니며, 선택 값들은 오지 않을 수 있음 ( 이 경우 아예 gone 처리 )

// ** 공통 출력 값
// idx, uuid, name, address, date, content, img_list, starting_chip, prize_list, duration_list, created_at,
// 상태 값 : event_state_flag, event_type_flag, pro_grade_flag
// 선택 값 : reg_end_level, max_entry, re_entry, early, add_on

// ** 대회별 출력 값
// 공식 : series_idx, series_name, series_start_date, series_end_date, series_created_at, ticket_name, ticket_number
// 공식 예선전 : series_idx, series_name, series_start_date, series_end_date, series_created_at, ticket_name, ticket_number
// 매장 : ticket_name, ticket_number
// 트라이아웃 : (없음)
// 프리롤 : remaining_ticket_number

const EventDetail = () => {
	const navigate = useNavigate()

	// 각 모달창 Open 체크 State
	const [isOfficialAgreeModalOpen, setIsOfficialAgreeModalOpen] =
		useState(false)
	const [isTryoutAgreeModalOpen, setIsTryoutAgreeModalOpen] = useState(false)
	const [isFreerollAgreeModalOpen, setIsFreerollAgreeModalOpen] =
		useState(false)

	// 자세히 보기 활성 체크 State
	const [isPosterDetail, setIsPostDetail] = useState(false)
	const [isInfoDetail, setIsInfoDetail] = useState(false)
	const [isPrizeDetail, setIsPrizeDetail] = useState(false)
	const [isDurationDetail, setIsDurationDetail] = useState(false)

	// 포스터 확대보기 State
	const [expandImgSrc, setExpandImgSrc] = useState(null)

	const [eventData] = useGetEventDetail()
	const [postOfficialEventRegister] = usePostOfficialRegister(
		setIsOfficialAgreeModalOpen
	)
	const [postFreerollEventRegister] = usePostFreerollRegister(
		setIsFreerollAgreeModalOpen
	)

	const gameDataList = [
		{
			label: 'TICKET',
			value: eventData?.data?.ticket_name,
		},
		{
			label: 'BUY-IN',
			value: eventData?.data?.ticket_number,
		},
		{
			label: 'STACK',
			value: convertMoney(eventData?.data?.starting_chip),
		},
		{
			label: 'LATE EARLY',
			value: eventData?.data?.early_end_level
				? `Level ${eventData?.data?.early_end_level} 이전`
				: null,
		},
		{
			label: 'EARLY STACK',
			value: eventData?.data?.early_chip
				? convertMoney(eventData?.data?.early_chip)
				: null,
		},
		{
			label: 'LATE REG.',
			value: eventData?.data?.reg_end_level
				? `Level ${eventData?.data?.reg_end_level} 이전`
				: null,
		},
		{
			label: 'ADD-ON',
			value: eventData?.data?.add_on,
		},
		{
			label: 'ADD-ON STACK',
			value: eventData?.data?.add_on_chip
				? convertMoney(eventData?.data?.add_on_chip)
				: null,
		},
		{
			label: 'RE-ENTRY LIMIT',
			value: eventData?.data?.re_entry
				? `${eventData?.data?.re_entry} times`
				: null,
		},
		{
			label: 'RE-ENTRY STACK',
			value:
				eventData?.data?.re_entry_chip?.length > 0
					? convertMoney(eventData?.data?.re_entry_chip[0])
					: null,
		},
		{
			label: 'ENTRY',
			value: eventData?.data?.max_entry
				? `${convertMoney(eventData?.data?.used_entry)} / ${convertMoney(
						eventData?.data?.max_entry
					)} `
				: null,
		},
		{
			label: 'REST TICKET',
			value: eventData?.data?.remaining_ticket_number
				? convertMoney(eventData?.data?.remaining_ticket_number)
				: null,
		},
	]

	const requiredProGrade =
		eventData?.data?.pro_grade_flag !== UNQUALIFIED
			? `${
					convertProGradeAsName[eventData?.data?.pro_grade_flag]
				} 프로 자격 이상 참여 가능`
			: '프로 자격 제한 없음'

	const prizeList = eventData?.data?.prize_list
	const durationList = eventData?.data?.duration_list

	return (
		<>
			{isOfficialAgreeModalOpen && (
				<AgreeModal
					title='공식 대회 신청 약관 동의'
					closeEvent={() => setIsOfficialAgreeModalOpen(false)}
					list={[
						{title: '공식 대회 신청 약관 (필수)', content: officalEventTerm},
					]}
					buttonLabel='신청하기'
					clickEvent={postOfficialEventRegister}
				/>
			)}

			{isTryoutAgreeModalOpen && (
				<AgreeModal
					title='트라이아웃 대회 신청 약관 동의'
					closeEvent={() => setIsTryoutAgreeModalOpen(false)}
					list={[
						{
							title: '트라이아웃 대회 신청 약관 (필수)',
							content: tryoutEventTerm,
						},
					]}
					buttonLabel='신청하기'
					clickEvent={() =>
						navigate(
							`/payment/event?eventName=${eventData?.data?.name}&eventIdx=${eventData?.data?.idx}&branchName=${eventData?.data?.branch_name}`
						)
					}
				/>
			)}

			{isFreerollAgreeModalOpen && (
				<AgreeModal
					title='프리롤 대회 신청 약관 동의'
					closeEvent={() => setIsFreerollAgreeModalOpen(false)}
					list={[
						{title: '프리롤 대회 신청 약관 (필수)', content: freerollEventTerm},
					]}
					buttonLabel='신청하기'
					clickEvent={postFreerollEventRegister}
				/>
			)}

			{expandImgSrc && (
				<ImageModal
					src={expandImgSrc}
					closeEvent={() => setExpandImgSrc(null)}
				/>
			)}

			<Style.Wrapper>
				<Banner imgList={eventData?.data?.img_list} />

				<Style.ContentDiv>
					{/* <Style.ContentDiv $active={isDetail}> */}
					{/* {!isDetail && <Style.HeaderCover />} */}

					<Style.HeaderDiv>
						<Style.ContentElement>
							<Style.TitleDiv $type={eventData?.data?.event_type_flag}>
								<h2>{eventData?.data?.name}</h2>
								<p>
									{convertEventTypeAsName[eventData?.data?.event_type_flag]}
								</p>
							</Style.TitleDiv>
							<h2>
								접수 시간 | {timestampCalculator(eventData?.data?.reg_date)}
							</h2>
							<h2>대회 시간 | {timestampCalculator(eventData?.data?.date)}</h2>
						</Style.ContentElement>
						<Style.ContentElement>
							<p>{eventData?.data?.address}</p>
							<p>
								{convertEventStateAsName[eventData?.data?.event_state_flag]} |{' '}
								{requiredProGrade}
							</p>
						</Style.ContentElement>
						<h2>{eventData?.data?.content}</h2>
					</Style.HeaderDiv>

					{[OFFICIAL, PRELIMINARY].includes(
						eventData?.data?.event_type_flag
					) && (
						<Style.Area>
							<Style.AreaTitleDiv>
								<h2>대회 시리즈 정보</h2>
							</Style.AreaTitleDiv>
							<Style.SeriesBtn
								onClick={() =>
									navigate(
										`/event/series/${eventData?.data?.series_idx}/detail`
									)
								}
							>
								<h2>{eventData?.data?.series_name}</h2>
								<img src={next} />
							</Style.SeriesBtn>
						</Style.Area>
					)}

					{eventData?.data?.poster_img && (
						<Style.Area>
							<Style.AreaTitleDiv>
								<h2>대회 포스터 보기</h2>
								<button onClick={() => setIsPostDetail(!isPosterDetail)}>
									{isPosterDetail ? '접기' : '자세히'}
									<img src={next} />
								</button>
							</Style.AreaTitleDiv>
							<Style.AreaBody $active={isPosterDetail}>
								<img
									src={eventData?.data?.poster_img}
									onClick={() => setExpandImgSrc(eventData?.data?.poster_img)}
								/>
							</Style.AreaBody>
						</Style.Area>
					)}

					<Style.Area>
						<Style.AreaTitleDiv>
							<h2>대회 정보</h2>
							<button onClick={() => setIsInfoDetail(!isInfoDetail)}>
								{isInfoDetail ? '접기' : '자세히'}
								<img src={next} />
							</button>
						</Style.AreaTitleDiv>
						<Style.AreaBody $active={isInfoDetail}>
							{gameDataList.map(
								(elem) =>
									elem?.value && (
										<Style.InfoElement>
											<h2>{elem?.label}</h2>
											<p>{elem?.value}</p>
										</Style.InfoElement>
									)
							)}
						</Style.AreaBody>
					</Style.Area>

					<Style.Area>
						<Style.AreaTitleDiv>
							<h2>프라이즈</h2>
							<button onClick={() => setIsPrizeDetail(!isPrizeDetail)}>
								{isPrizeDetail ? '접기' : '자세히'}
								<img src={next} alt='next' />
							</button>
						</Style.AreaTitleDiv>
						<Style.AreaBody $active={isPrizeDetail}>
							{prizeList ? (
								prizeList?.map((elem) => (
									<Style.PrizeElement>
										<h2>{elem[0]}</h2>
										<p>{elem[1]}</p>
									</Style.PrizeElement>
								))
							) : (
								<p>프라이즈 데이터가 없습니다.</p>
							)}
						</Style.AreaBody>
					</Style.Area>

					<Style.Area>
						<Style.AreaTitleDiv>
							<h2>듀레이션</h2>
							<button onClick={() => setIsDurationDetail(!isDurationDetail)}>
								{isDurationDetail ? '접기' : '자세히'}
								<img src={next} />
							</button>
						</Style.AreaTitleDiv>
						<Style.AreaBody $active={isDurationDetail}>
							<Style.DurationTitleDiv>
								<p>Level</p>
								<p>S/B</p>
								<p>B/B</p>
								<p>Ante</p>
								<p>Minute</p>
							</Style.DurationTitleDiv>
							{durationList?.map((row) => {
								const reorderRow = [...row.slice(0, 1), ...row.slice(2), row[1]] // 요구사항 변경으로 두 번째 값을 마지막에 출력해야 해서 추가함

								return (
									<Style.DurationElement $break={row[0] === 'break'}>
										{reorderRow.map((data) => (
											<p>{data}</p>
										))}
									</Style.DurationElement>
								)
							})}
						</Style.AreaBody>
					</Style.Area>
				</Style.ContentDiv>

				<Style.DetailBtnDiv>
					{[OFFICIAL].includes(eventData?.data?.event_type_flag) && (
						<DefaultButton
							caution
							clickEvent={() => setIsOfficialAgreeModalOpen(true)}
						>
							공식 대회 신청하기
						</DefaultButton>
					)}
					{[TRYOUT].includes(eventData?.data?.event_type_flag) && (
						<DefaultButton
							caution
							clickEvent={() => setIsTryoutAgreeModalOpen(true)}
						>
							트라이아웃 대회 결제하기
						</DefaultButton>
					)}
					{[FREEROLL].includes(eventData?.data?.event_type_flag) && (
						<DefaultButton
							caution
							clickEvent={() => setIsFreerollAgreeModalOpen(true)}
						>
							프리롤 대회 참가권 수령
						</DefaultButton>
					)}
				</Style.DetailBtnDiv>
			</Style.Wrapper>
		</>
	)
}

export default EventDetail
